<ng-template #loader>
  <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
</ng-template>
<div class="boma-content" *ngIf="loadedMapsApi$ | async; else loader">
  <div *ngIf="!justMap" class="formgrid grid">
    <div [style.display]="enableSearch ? '' : 'none'" class="field col-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
        <input
          #search
          (keydown.enter)="$event.preventDefault()"
          [(ngModel)]="typedAddress"
          autocapitalize="off"
          autocorrect="off"
          class="form-control"
          pInputText
          placeholder="Search the address or nearest location"
          spellcheck="off"
          type="text"
        />
      </div>
    </div>

    <div class="field md:col-6">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Lat</span>
        <input
          [(ngModel)]="userSelectedCoordinates.lat"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          class="form-control"
          id="lat"
          name="lat"
          pInputText
          placeholder="Latitude"
          spellcheck="off"
          type="text"
        />
      </div>
    </div>
    <div class="field md:col-6">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Long</span>
        <input
          [(ngModel)]="userSelectedCoordinates.long"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          class="form-control"
          id="long"
          name="long"
          pInputText
          placeholder="Longitude"
          spellcheck="off"
          type="text"
        />
      </div>
    </div>
    <div class="field md:col-6">
      <p-button
        (click)="findCoordinates()"
        label="Goto Coordinates"
        styleClass="p-button-outlined"
      ></p-button>
    </div>
  </div>

  <div class="col-12 px-0">
    <div
      [ngClass]="{
        'card no-gutter widget-overview-box widget-overview-box-4': !justMap
      }"
    >
      <ng-container *ngIf="!justMap">
        <span class="overview-icon">
          <i class="material-icons-round mi-location-on"></i>
        </span>
        <span class="overview-title">{{ title }}</span>

        <button
          (click)="editMode = !editMode"
          class="p-button-text p-button-secondary"
          icon="material-icons-round mi-edit-location-alt"
          pButton
          pRipple
          style="float: right"
        ></button>
      </ng-container>

      <div class="grid overview-detail text-left">
        <div class="col-12">
          <!-- EXTRACT THIS TO THE WEB SELECTOR -->
          {{ this.latitude }} {{ this.longitude }}
          <google-map
            [options]="mapOptions"
            (mapInitialized)="onMapReady($event)"
            (mapClick)="mapClicked($event)"
          >
            <!-- <map-marker (mapDragend)="markerDragEnd($event)"> </map-marker> -->
          </google-map>

          <ng-container *ngIf="!justMap">
            <p-messages *ngIf="editMode && !markers?.length" severity="info">
              <ng-template pTemplate>
                <span class="custom-message">
                  <strong>Tip:</strong> You can click to place the marker
                  anywhere within your country.</span
                >
              </ng-template>
            </p-messages>
          </ng-container>
        </div>
        <div *ngIf="!justMap" class="col-12">
          <div class="formgrid grid">
            <!--                Construct an edit form here-->
            <p-messages *ngIf="editForm.dirty" severity="info">
              <ng-template pTemplate>
                <span class="custom-message">
                  <strong
                    >Updates have been made, save to avoid losing
                    changes.</strong
                  ></span
                >
              </ng-template>
            </p-messages>

            <form
              #editForm="ngForm"
              (ngSubmit)="emit()"
              class="col-12"
              id="editForm"
            >
              <label *ngIf="editMode" for="line1">Address Line 1</label>
              <input
                [(ngModel)]="newAddress.line1"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line1"
                name="line1"
                pInputText
                placeholder="Street Address"
                spellcheck="off"
                type="text"
              />

              <label *ngIf="editMode" for="line2">Address Line 2</label>
              <input
                [(ngModel)]="newAddress.line2"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line2"
                name="line2"
                pInputText
                placeholder="Unit, Suite, Floor etc."
                spellcheck="off"
                type="text"
              />
              <label *ngIf="editMode" for="line4">Address Line 3</label>
              <input
                [(ngModel)]="newAddress.line4"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="line4"
                name="line4"
                pInputText
                placeholder="Enter Suburb"
                spellcheck="off"
                type="text"
              />

              <label *ngIf="editMode" for="town">City / Town / Village</label>
              <input
                [(ngModel)]="newAddress.town"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="town"
                name="town"
                pInputText
                placeholder="City / Town / Village"
                spellcheck="off"
                type="text"
              />
              <label *ngIf="editMode" for="province"
                >Province / Region / State</label
              >
              <input
                [(ngModel)]="newAddress.province"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="province"
                name="province"
                pInputText
                placeholder="Province"
                spellcheck="off"
                type="text"
              />
              <label *ngIf="editMode" for="postalcode"
                >Postal Code / Zip Code</label
              >
              <input
                [(ngModel)]="newAddress.postalCode"
                [disabled]="!editMode"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                class="form-control"
                id="postalcode"
                name="postalcode"
                pInputText
                placeholder="Enter Postal Code"
                spellcheck="off"
                type="text"
              />

              <div *ngIf="!editMode" class="field col-12">
                <p
                  *ngIf="!newAddress['postalCode'] || !newAddress['Suburb']"
                  class="mt-4"
                >
                  Something not looking right?
                  <a (click)="editMode = !editMode" class="cursor-pointer"
                    >Update it now</a
                  >.
                </p>
              </div>

              <!-- <button
              (click)="emitPoint()"
              *ngIf="editMode"
              class="mt-3 p-button-success boma-shadow"
              icon="pi pi-save"
              label="Update"
              pButton
              pRipple
              type="submit"
            ></button> -->
            </form>

            <div class="col-12 mt-3">
              <strong>Latitude:</strong> {{ latitude }}<br />
              <strong>Longitude:</strong> {{ longitude }}<br />
              <br />
              <ng-container *ngIf="this.newAddress['line3']">
                {{ this.newAddress['line3'] }}</ng-container
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
